import { loadStripe } from '@stripe/stripe-js';
import api from '~/services/api';
// import toast from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import { STRIPE_PK } from '../services/config';
import { ConversionApiMeta, getFbc, getFbp } from './meta';
import { ConversionApiTiktok, getTtclid, getTtp } from './tiktok';
// import { getVstId } from './tracking';

export async function handleBuyStripe(
  userId,
  email,
  whatsapp,
  stripe_price_id,
  urlCancel
) {
  const stripePromise = loadStripe(STRIPE_PK);

  const subscriptionObj = await api.get('/subscription');
  const subscription = subscriptionObj && subscriptionObj.data;

  if (
    !subscription ||
    (subscription && subscription.payment_status !== 'active')
  ) {
    const uuid = uuidv4();

    const userregistrationtracking = await api.get('/userregistrationtracking');

    // const vst_id = await getVstId(userregistrationtracking);
    const fbc = await getFbc(userregistrationtracking);
    const fbp = await getFbp(userregistrationtracking);
    const ttclid = await getTtclid(userregistrationtracking);
    const ttp = await getTtp(userregistrationtracking);

    try {
      ConversionApiMeta({
        eventId: uuid,
        eventName: 'InitiateCheckout',
        email,
        phone: whatsapp,
        externalId: userId,
        fbc,
        fbp,
      });
    } catch (err) {
      console.log('Erro ao enviar InitiateCheckout da Meta', err);
    }

    try {
      ConversionApiTiktok({
        eventId: uuid,
        eventName: 'InitiateCheckout',
        email,
        phone: whatsapp,
        externalId: userId,
        ttclid,
        ttp,
      });
    } catch (err) {
      console.log('Erro ao enviar InitiateCheckout do Tiktok', err);
    }

    const stripe = await stripePromise;

    const session = await api.post('/createsession', {
      email,
      stripe_price_id,
      urlCancel,
    });

    // if (type) sendWelcomeMessage();

    const sessionId = session.data.id;

    await stripe.redirectToCheckout({
      sessionId,
    });
  } else {
    // toast.success('Você já é PRO');
  }

  return 0;
}
